import { useIsFetching as useIsFetchingQuery, useIsMutating as useIsMutatingMutation } from "@tanstack/react-query"
import type { MutationKey, QueryKey } from "@tanstack/react-query"

function useIsFetching(queryKey: QueryKey): boolean {
    const count: number = useIsFetchingQuery({ queryKey })

    return count > 0
}

function useIsMutating(mutationKey: MutationKey): boolean {
    const count: number = useIsMutatingMutation({ mutationKey })

    return count > 0
}

export { useIsFetching, useIsMutating }
